
import api from './../helpers/api'

// const API_URL = 'https://localhost:8000/api';
// const API_URL = 'http://desktop-jr58gml/server/public/api';

class CategoryService{    
    
    //create wharehouse
    create_category(formData){
        return api.post(`/add_category`,formData);
    }

    //get wharehouses
    get_categories(){
        return api.get(`/get_categories`);
    }

    //show wharehouse
    get_category(id){
        return api.post(`/get_category/${id}`, );
    }

    //edit category
    edit_category(formData){
        return api.post(`/edit_category/${formData.id}`, {
            name:        formData.name,
            description: formData.description || '',
        });
    }

    delete_category(id){
        return api.post(`/delete_category/${id}`);
    }

    delete_wharehouse(id){
        return api.post(`/delete/${id}`, );
    }

    //expense categories
    create_expense_category(category){
        return api.post(`/add_expense_category`, {
            name:        category.name,
            description: category.description,
        });
    }
    //get expenses category
    get_expense_category(){
        return api.get(`/get_expenses_category`);
    }

    edit_expense_category(category){
        return api.post(`/edit_expense_category`, {
            id:          category.id,
            name:        category.name,
            description: category.description,
        });
    }

    delete_expense_category(id){
        return api.post(`/delete_expense_category/${id}`);
    }

    //get expenses
    get_expenses(){
        return api.get(`/get_expenses`);
    }

    create_expense(expense){
        return api.post(`/create_expense`, {
            category_id: expense.category_id,
            amount:      expense.amount,
            date:        expense.date,
            // Only sent when the caller established this user may file for a past
            // day; the API rejects it otherwise, and omitting it records today.
            record_date: expense.record_date || undefined,
            description: expense.description,
        });
    }

    edit_expense(expense){
        return api.post(`/edit_expense`, {
            id:          expense.id,
            category_id: expense.category_id,
            amount:      expense.amount,
            date:        expense.date,
            description: expense.description,
        });
    }

    delete_expense(id) {
        return api.delete(`/delete_expense/${id}`);
    }
}
export default new CategoryService;